import api from './users_institutions';

/**
 * Ask the backend to generate a 6-digit verification code and email it to the given address.
 * @param {string} email - Recipient email address
 * @param {string} [lang] - Language code for the email content ('en' | 'fr' | 'ar')
 * @returns {Promise} Response confirming the email was sent
 */
export const sendVerificationEmail = async (email, lang) => {
    try {
        const response = await api.post('/mail/send-verification/', { email, lang });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

/**
 * Verify a submitted code against the one generated for the given email.
 * @param {string} email - Recipient email address
 * @param {string} code - 6-digit code entered by the user
 * @returns {Promise} Response with { verified: boolean }
 */
export const verifyEmailCode = async (email, code) => {
    try {
        const response = await api.post('/mail/verify-code/', { email, code });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

/**
 * Reset a user's password. Requires that the email was verified via verifyEmailCode
 * within the last 10 minutes.
 * @param {string} email - Account email address
 * @param {string} newPassword - New password to set
 * @returns {Promise} Response confirming the password was reset
 */
export const resetPassword = async (email, newPassword) => {
    try {
        const response = await api.post('/mail/reset-password/', { email, new_password: newPassword });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};
